var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"special-note"},[_c('Header'),_c('div',{staticClass:"special-note__menu"},[_c('Menu'),_c('List',{attrs:{"options":"11","special":"true"}})],1),_c('Rodo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }